import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white relative flex h-[50px] w-[69%] items-center justify-between md:w-full',
    button: 'flex min-w-[50px] cursor-pointer items-center justify-center',
    buttonPlus: 'flex min-w-[50px] cursor-pointer items-center justify-center',
    input: 'heading-s w-full text-center outline-0'
  },
  variants: {
    loading: {
      true: {
        button: 'opacity-0',
        buttonPlus: 'opacity-0',
        input: 'opacity-0'
      }
    },
    isMaxReached: {
      true: {
        buttonPlus: 'opacity-30'
      }
    }
  }
});
